var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "isClose": true,
      "className": "popGuide",
      "show": _vm.popGuideShow,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": true,
      "confirmText": "Go"
    },
    on: {
      "update:show": function ($event) {
        _vm.popGuideShow = $event;
      },
      "confirm": _vm.popGuideConfirm
    }
  }, [_vm.guideList.length > 0 ? _c('div', {
    staticClass: "pop-guide",
    class: `_${_vm.guideList[_vm.currentIndex].type}`
  }, [_vm.guideList[_vm.currentIndex].name ? _c('div', {
    staticClass: "pop-guide__title"
  }, [_vm._v(_vm._s(_vm.guideList[_vm.currentIndex].name))]) : _vm._e(), _c('div', {
    staticClass: "pop-guide-main"
  }, [_vm.guideList.length > 1 ? _c('div', {
    staticClass: "pop-guide-arrow left",
    class: _vm.currentIndex == 0 && 'disable',
    on: {
      "click": _vm.prevSlide
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/guide/guide-icon-arrow.png`),
      "alt": ""
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "pop-guide__img"
  }, [_c('div', {
    staticClass: "slider-track",
    style: {
      transform: `translateX(-${_vm.currentIndex * 100}%)`
    }
  }, _vm._l(_vm.guideList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "slide",
      class: item.type
    }, [_c('img', {
      attrs: {
        "src": require(`@images/guide/${item.img}`),
        "alt": ""
      }
    })]);
  }), 0)]), _vm.guideList.length > 1 ? _c('div', {
    staticClass: "pop-guide-arrow right",
    class: _vm.currentIndex == _vm.guideList.length - 1 && 'disable',
    on: {
      "click": _vm.nextSlide
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/guide/guide-icon-arrow.png`),
      "alt": ""
    }
  })]) : _vm._e()]), _vm.guideList[_vm.currentIndex].earn ? _c('div', {
    staticClass: "pop-guide__earn"
  }, [_c('em', [_vm._v("Earn")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.guideList[_vm.currentIndex].earn)
    }
  })]) : _vm._e()]) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };